(() => {
  try {
    const assetBase = (() => {
      const href =
        document.querySelector('link[href*="/cdn/shop/t/"][href*="/assets/"]')?.getAttribute('href') ||
        document.querySelector('script[src*="/cdn/shop/t/"][src*="/assets/"]')?.getAttribute('src') ||
        '';
      const match = href.match(/((?:https?:)?\/\/[^/]+\/cdn\/shop\/t\/\d+\/assets)/);
      return match ? match[1] : 'https://charmenova.com/cdn/shop/t/5/assets';
    })();

    const ensureStylesheet = (file, flag) => {
      if (document.querySelector(`link[${flag}]`)) return;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `${assetBase}/${file}`;
      link.setAttribute(flag, '1');
      document.head.appendChild(link);
    };

    // Header localization + cart overlays (fixes white-on-white + polish)
    ensureStylesheet('charme-ui-overlays.css', 'data-charme-overlays');

    const runCampaignFix = () => {
      if (window.__charmeSkyFixApplied) return;

      const campaignSection = document.querySelector('[id*="__charme_campaign_break"]');
      if (!campaignSection) return;

      ensureStylesheet('charme-campaign-frame.css', 'data-charme-campaign-css');

      campaignSection.classList.add('charme-campaign-section');
      campaignSection.classList.remove('section');
      campaignSection.querySelectorAll('.charme-campaign__content').forEach((n) => n.remove());

      const root = campaignSection.querySelector('.charme-campaign');
      if (!root) return;

      const video = root.querySelector('video, [data-charme-campaign-video]');
      if (video) {
        let src = video.getAttribute('src') || video.getAttribute('data-src') || '';
        if (/\/t\/\d+\//.test(src)) src = src.replace(/\/t\/\d+\//, '/t/5/');
        if (!src) src = `${assetBase}/campaign-badr-sec4.mp4`;
        if (video.getAttribute('src') !== src) {
          video.src = src;
          video.load();
        }
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.autoplay = true;
        video.loop = true;
        video.controls = false;
        video.removeAttribute('controls');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('autoplay', '');
        const play = () => video.play().catch(() => {});
        play();
        document.addEventListener('touchstart', play, { once: true, passive: true });
        document.addEventListener('scroll', play, { once: true, passive: true });
      }

      window.__charmeSkyFixApplied = true;
    };

    const run = () => {
      ensureStylesheet('charme-ui-overlays.css', 'data-charme-overlays');
      runCampaignFix();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
  } catch (e) {}
})();

/* bust-1786841074 */
